import router from './router'
import { getStore, setStore, removeStore } from '@/utils/util'
import { clearActivationPending, markActivationPending } from '@/utils/activation'
// 一门APP桥
import { jsBridge } from "@/assets/js/jsbridge-mini.js";
const whiteList = ['/login'];//白名单

import store from './store'
import { getUserInfo } from '@/api/index'
router.beforeEach(async (to, from, next) => {
  var isApp = true//是否是一门APP
  var IMEI = ''//设备标示
  // 判断环境是否APP
  if (/LT-APP/.test(navigator.userAgent) && !getStore('IMEI')) {
    isApp = true
    jsBridge.ready(function () {
      jsBridge.getIMEI(function (id) {
        // id 设备标示
        setStore('IMEI', id)
      });
    });
  }
  // 手机获取IMEI


// uniapp 打包
if(window.plus){ 
  setStore('IMEI',plus.device.imei)
  // 在这里调用5+ API 
}else{// 兼容老版本的plusready事件 
  document.addEventListener('plusready', function () {
    setStore('IMEI',plus.device.imei)
  })
} 

  // 设置标题
  document.title = to.meta.title
  if (to.query.IMEI || getStore('IMEI')) {
    setStore('IMEI', to.query.IMEI || getStore('IMEI'))
    IMEI = to.query.IMEI || getStore('IMEI')
  }
  if (to.query.isAcive) {
    markActivationPending()
  }
  // alert(getStore('IMEI'))
  // 获取是否激活
  let userInfo = store.state.user.info;
  if (!userInfo.brand_info && to.path != '/login') {
    // 获取详情
    let result = await getUserInfo().then(res => res.data).catch(error => error)
    // 未激活
    if (result.code === 20001) {
      markActivationPending()
      return next({ path: '/login', query: { isAcive: 1, IMEI: IMEI } })
    } else if (result.code != 0) {
      return next({ path: '/login', query: { IMEI: IMEI } })
    } else {
      clearActivationPending()
      store.commit('user/SET_USER_INFO', result.data);
      if (getStore('token')) {
        return next()
      } else {
        return next({ path: '/login', query: { IMEI: IMEI } })
      }
    }
  }
  if (getStore('token')) {
    return next()
  } else {
    // 如果是app
    var info = store.state || store.state.user || store.state.user.info || null
    console.log(info)
    if (whiteList.indexOf(to.path) !== -1) {
      return next()
    } else {
      // // 非app需要带标示进入  IMEI=xxxx
      // next({path:'/login',query:{IMEI:IMEI}})
      if (info) {
        return next({ path: '/login' })
      } else {
        markActivationPending()
        return next({ path: '/login', query: { isAcive: 1, IMEI: IMEI } })
      }
    }
  }
})
router.afterEach(async (to) => {
  // setTimeout(() => {
  // console.log(document.getElementsByTagName('input'))
  //   document.getElementsByTagName('input').setAttribute('autocomplete',false)
  // }, 500);
  if (to.path === '/login') {
    removeStore('token')
  }
})
